import React, { useEffect, useState } from "react";
import PageContainer from "../../ui/layout/page";
import PageFooter from "../../ui/layout/page/footer";
import FormFullWidthContainer from "../../ui/layout/page/forms-container/form-full-width-container";
import TypographyContainer from "../../ui/layout/page/typography-container/typography-base-container";
import TypographyItemContainer from "../../ui/layout/page/typography-container/typography-item-container";
import CustomLink from "../../ui/widgets/link";
import CustomTypography from "../../ui/widgets/typography";
import ErrorHeader from "./errorHeader";
import PageContent from "../../ui/layout/page/content";
import { StyledEngineProvider } from "@mui/material";
import "./styles.scss";
import {
  Provider as MessageSourceProvider,
  useMessageSource,
} from "react-message-source";
import { loadMessagesSource } from "../../context/loaders";
import { getPersistedLanguage } from "../../context/languageContext";
import NetworkError from "../../api/http/networkError";

const ErrorContent = (): React.JSX.Element => {
  const { getMessage } = useMessageSource();

  return (
    <PageContainer>
      <div className="scd-error-page">
        <ErrorHeader />
        <PageContent>
          <div className="scd-section-helper-md">
            <FormFullWidthContainer>
              <TypographyContainer>
                <TypographyItemContainer>
                  <CustomTypography variant="h3">
                    {getMessage("Error.title")}
                  </CustomTypography>
                </TypographyItemContainer>
                <TypographyItemContainer>
                  <CustomTypography variant="body2">
                    {getMessage("Error.description")}
                  </CustomTypography>
                </TypographyItemContainer>
              </TypographyContainer>
              <TypographyContainer>
                <TypographyItemContainer>
                  <CustomLink
                    onClick={(): void => {
                      window.location.reload();
                    }}
                  >
                    {getMessage("Error.link-text", "Erneut versuchen")}
                  </CustomLink>
                </TypographyItemContainer>
              </TypographyContainer>
            </FormFullWidthContainer>
            <div className="scd-section-pusher-md">
              <TypographyContainer>
                <TypographyItemContainer>
                  <CustomTypography variant="h4">
                    {getMessage("Error.empty-pdf.header")}
                  </CustomTypography>
                </TypographyItemContainer>
                <TypographyItemContainer>
                  <CustomLink
                    href={getMessage("Error.empty-pdf.link")}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {getMessage("Error.empty-pdf")}
                  </CustomLink>
                </TypographyItemContainer>
              </TypographyContainer>
            </div>
          </div>
        </PageContent>
        <PageFooter />
      </div>
    </PageContainer>
  );
};

const ErrorScreen = (): React.JSX.Element => {
  const messageFileNamePrefix = "error_";
  const language = getPersistedLanguage();
  const [messages, setMessages] = useState(null);

  useEffect(() => {
    loadMessagesSource(language, messageFileNamePrefix)
      .then((result) => {
        setMessages(result);
      })
      .catch(() => {
        throw new NetworkError(
          "Message source failed loading in Error Screen with given language: " +
            language,
        );
      });
  }, [language]);

  return (
    messages && (
      <MessageSourceProvider value={messages}>
        <StyledEngineProvider injectFirst>
          <ErrorContent />
        </StyledEngineProvider>
      </MessageSourceProvider>
    )
  );
};

export default ErrorScreen;
